import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import Imagen from '../../../assets/images/bg-indicador-pending.png'
import Amipass from '../../../assets/images/amipasswhite.png'

export function Pending() {
  return (
    <Box
      w="100%"
      minWidth={593}
      padding="20px"
      minHeight={300}
      borderRadius={15}
      position="relative"
      backgroundSize="cover"
      backgroundImage={Imagen}
      backgroundRepeat="no-repeat"
      justifyContent="center"
      alignItems="center"
      display="flex"
    >
      <img
        src={Amipass}
        alt="amipass"
        style={{ position: 'absolute', top: 15, left: 15 }}
      />
      <Text variant="h5" textAlign="center" color="#fff">
        ¡Pronto tendremos novedades para ti!
      </Text>
    </Box>
  )
}
